const KEY = 'trade-history-filters-v1';
export const EMPTY_FILTERS = { startDate: '', endDate: '', symbol: '' };

export function readFilters() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    return Object.fromEntries(Object.keys(EMPTY_FILTERS).map(key => [key, typeof saved?.[key] === 'string' ? saved[key] : '']));
  } catch (_) { return { ...EMPTY_FILTERS }; }
}

export function storeFilters(filters) {
  try { sessionStorage.setItem(KEY, JSON.stringify(filters)); } catch (_) { /* Storage can be unavailable. Filtering still works. */ }
}

function localMidnight(value, nextDay = false) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error('Enter valid dates.');
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(0);
  date.setFullYear(year, month - 1, day);
  date.setHours(0, 0, 0, 0);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) throw new Error('Enter valid dates.');
  // Advance the local CALENDAR date, not 24 hours: DST days may have 23/25 hours.
  if (nextDay) date.setDate(date.getDate() + 1);
  return date.toISOString();
}

export function historyQuery(filters, page) {
  if (filters.startDate && filters.endDate && filters.startDate > filters.endDate) throw new Error('Start date must be on or before end date.');
  return { page, page_size: 25, ...(filters.startDate ? { start: localMidnight(filters.startDate) } : {}),
    ...(filters.endDate ? { end: localMidnight(filters.endDate, true) } : {}),
    ...(filters.symbol ? { symbol: filters.symbol } : {}) };
}